module.exports = __webpack_public_path__ + "static/media/icon-web-dev.22d1e1bd.svg";